import { api } from "@/app/app.api";
import { objectToFormData } from "@/shared/utils/data";
import { RequestMethod } from "@/shared/utils/RequestMethod";
import { camelToSnake } from "caseparser";

export const transactionsApi = api
  .enhanceEndpoints({ addTagTypes: ["tax-id", "branchs"] })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      updateTaxId: builder.mutation({
        query: ({ branchId, tax_id, iva, comment_ticket }) => ({
          url: `branchs/${branchId}/tax-id`,
          method: RequestMethod.POST,
          body: objectToFormData(
            camelToSnake({
              branchId,
              tax_id,
              iva,
              comment_ticket,
            })
          ),
          formData: true,
        }),
        invalidatesTags: ["tax-id", "branchs"],
      }),
    }),
  });

export const { useUpdateTaxIdMutation } = transactionsApi;
